import React, { useState, useEffect } from "react";
import { fetchPostBySlug } from "./api";
import { useParams } from "react-router-dom";
import Nav from "../nav";
import "../blogs/blog.css";
import Footer from "../footer";

function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    const getPost = async () => {
      const data = await fetchPostBySlug(slug);
      setPost(data);
    };

    getPost();
  }, [slug]);

  if (!post) return <p>Loading...</p>;

  return (
    <>
      <Nav />
      <div className="container detail">
        <div className="row">
          <div className="col-sm-12 col-md-11 col-lg-9">
            {/* <h1>{post.title.rendered}</h1> */}
            <h1 dangerouslySetInnerHTML={{ __html: post.title.rendered }} />

            <div dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
            <p>{post.tags}</p>

            {/* {post._embedded?.["wp:featuredmedia"] 
                && (
                    <img
                        src={post._embedded["wp:featuredmedia"][0].source_url}
                        alt=""
                    />
                )
                } */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default BlogDetail;
